import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ProcessDraftStepSchema } from '../process-draft/process-draft-step.schema';
import { ProcessDraftEventNodeSchema } from '../process-node/process-node.schema';
import { UserDisplayIdentitySchema } from '../user/user.schema';
export const StepTemplateNameSchema = z.string().trim().min(1).max(120);
export const StepTemplateDescriptionSchema = z.string().max(1000);
/**
 * The draft-step fields a Schrittvorlage freezes. Single source of truth: the
 * wire schema picks from it and the backend's stored type derives from it, so
 * the whitelist is stated once.
 */ export const STEP_TEMPLATE_STEP_FIELDS = [
    'actionType',
    'inputs',
    'task',
    'rules',
    'assignedTo',
    'assignedToModel',
    'helpers',
    'whoElseDoesThis',
    'generatedName',
    'generatedDescription'
];
const stepFieldMask = Object.fromEntries(STEP_TEMPLATE_STEP_FIELDS.map((field)=>[
        field,
        true
    ]));
/**
 * A step frozen into a Schrittvorlage. `nodeId` is the template-local node
 * identity (the source `stableStepId` at save time); the edges inside
 * `inputs[]` reference these ids, never the source draft's ids.
 */ export const StepTemplateStepSchema = ProcessDraftStepSchema.pick(stepFieldMask).extend({
    nodeId: ObjectIdSchema
});
/**
 * An event frozen into a Schrittvorlage. `eventKind` is deliberately not
 * stored: a saved start event comes back as an intermediate event on insert.
 */ export const StepTemplateEventSchema = ProcessDraftEventNodeSchema.pick({
    eventType: true,
    name: true,
    description: true
}).extend({
    nodeId: ObjectIdSchema
});
/** Template-relative node position, min-normalised to origin `{0,0}`. */ export const StepTemplatePositionSchema = z.object({
    nodeId: ObjectIdSchema,
    x: z.number(),
    y: z.number()
});
export const StepTemplateSchema = z.object({
    _id: ObjectIdSchema,
    name: StepTemplateNameSchema,
    description: StepTemplateDescriptionSchema.default(''),
    steps: z.array(StepTemplateStepSchema),
    events: z.array(StepTemplateEventSchema),
    positions: z.array(StepTemplatePositionSchema),
    createdBy: UserDisplayIdentitySchema,
    createdAt: z.string(),
    updatedAt: z.string()
});

//# sourceMappingURL=step-template.schema.js.map